import React, { Component } from 'react';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import Home from 'pages/home';
import Login from 'pages/login';
import Platform from 'pages/platform';
import User from 'pages/simple/user';
import Privacy from 'pages/simple/privacy';
import Children from 'pages/simple/children';
import Anchor from 'pages/simple/anchor';
import Autosubscription from 'pages/simple/autosubscription';
import Complaint from 'pages/simple/complaint';
import AlbumDetail from 'pages/detail';

class Layout extends Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    render() {
        return (<Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/home" component={Home} />
            <Route exact path="/login" component={Login} />
            <Route path="/platform" component={Platform} />
            <Route exact path="/simple/user" component={User} />
            <Route exact path="/simple/privacy" component={Privacy} />
            <Route exact path="/simple/children" component={Children} />            
            <Route exact path="/simple/anchor" component={Anchor} />
            <Route exact path="/simple/complaint" component={Complaint} />
            <Route exact path="/simple/autosubscription" component={Autosubscription}/>
            <Route exact path="/detail" component={AlbumDetail} />
            <Redirect from="/*" to="/" />
        </Switch>);
    }
}

export default withRouter(Layout);